import React, { useEffect, useState } from 'react';
import styles from '../../../../styles/materialVideo.module.css';
import { Form, Button, Modal, ListGroup } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import axios from '../../../../constents/axios';
import { GrChapterAdd } from "react-icons/gr";
import { CiSquareRemove } from "react-icons/ci";

const ORACLE_STORAGE_URL = process.env.REACT_APP_ORACLE_STORAGE_URL;
const AUTH_TOKEN = process.env.REACT_APP_AUTH_TOKEN;

const AddNewVideo = () => {
  const [materialData, setMaterialData] = useState({});
  const [caption, setCaption] = useState('');
  const [link, setLink] = useState('');
  const [file, setFile] = useState(null);
  const [date, setDate] = useState('');
  const [description, setDescription] = useState('');
  const [message, setMessage] = useState('');
  const [youtubeLink, setYoutubeLink] = useState('');
  const [publishDemo, setPublishDemo] = useState('0');
  const [chapterData, setChapterData] = useState([]); 
  const [currentChapterName, setCurrentChapterName] = useState(''); 
  const [currentChapterTime, setCurrentChapterTime] = useState(''); 
  const [showChapterForm, setShowChapterForm] = useState(false);
  const [showQuestionForm, setShowQuestionForm] = useState(false); 
  const [submitted, setSubmitted] = useState(false); 
  const [questionData, setQuestionData] = useState([]);
  const [currentQuestion, setCurrentQuestion] = useState('');
  const [currentOptions, setCurrentOptions] = useState(['', '', '', '']);
  const [currentAnswerOption, setCurrentAnswerOption] = useState('');
  const [currentQuestionTime, setCurrentQuestionTime] = useState("");
  const [currentQuestionTimeInMinutes, setCurrentQuestionTimeInMinutes] = useState(0);  
  const [currentExplanation, setCurrentExplanation] = useState('');
  const [videoId, setVideoId] = useState(null); 
  const [isYoutube, setIsYoutube] = useState(false);
  const [isLive, setIsLive] = useState(false);
  const [subject, setSubject] = useState('');
  const [project, setProject] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [dragActive, setDragActive] = useState(false);
  const navigate = useNavigate();

  const { courseName, currentTopicName, currentSubTopicName } = materialData;

const handleAddNewVideo = async (e) => {
  e.preventDefault();
  setIsSubmitting(true); // start loading

  let uploadedUrl = null;
  if (!isYoutube) {
    uploadedUrl = await uploadToOracle();
    if (!uploadedUrl) {
      setIsSubmitting(false); // stop loading on error
      return;
    }
    setLink(uploadedUrl);
  }

  try {
    const response = await axios.post(`/add-newvideo`, {
      course_id: `${courseName}`,
      topics: `${currentTopicName}`,
      subtopic: `${currentSubTopicName}`,
      caption,
      description,
      materialLink: uploadedUrl || link,
      youtubeLink,
      is_free: publishDemo,
      date,
      chapters: chapterData,
      is_live: isLive
    }, {
      headers: {
        'autherisation': `V9YlI4AgRJa97h9JT45acmijLliEcCEMnxZLtL7VlnWVETZuitk2MYoj0pCcrmHa`,
      }
    });

    const id = response.data.data;
    setVideoId(id);
    setShowQuestionForm(true);
    setSubmitted(true);
  } catch (error) {
    console.error('Error adding video:', error);
  }

  setIsSubmitting(false); // stop loading after all done
};



  const handleAddVideoQuestion = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`/add-videoQuestion`, {
        course_id: `${courseName}`,
        video_id: videoId,
        questionData
      },{
        headers: {
            'autherisation': `V9YlI4AgRJa97h9JT45acmijLliEcCEMnxZLtL7VlnWVETZuitk2MYoj0pCcrmHa`,
        }
    });
      navigate(`/studentJourney/${courseName}`);
    } catch (error) {
      console.error('Error adding video:', error);
    }
  };

  const handleCloseQuestionForm = () => {
    setShowQuestionForm(false);
    if (submitted) {
      navigate(`/studentJourney/${courseName}`);
    }
  };

  const handleChangeCaption = (e) => setCaption(e.target.value);
  const handleChangeLink = (e) => setLink(e.target.value);
const handleFile = (e) => {
  const selectedFile = e.target.files?.[0];
  if (selectedFile && selectedFile.type.startsWith('video/')) {
    setFile(selectedFile);
  } else {
    alert('Please upload a valid video file.');
    e.target.value = '';
  }
};

const handleDrop = (e) => {
  e.preventDefault();
  setDragActive(false);
  const droppedFile = e.dataTransfer.files[0];
  if (droppedFile && droppedFile.type.startsWith('video/')) {
    setFile(droppedFile);
  } else {
    alert('Please upload a valid video file.');
  }
};

const handleDragOver = (e) => {
  e.preventDefault();
  setDragActive(true);
};

const handleDragLeave = () => {
  setDragActive(false);
};

  const handleChangeDate = (e) => setDate(e.target.value);
  const handleChangeYoutubeLink = (e) => setYoutubeLink(e.target.value);
  const handleChangePublishDemo = (e) => setPublishDemo(e.target.value === 'publishYes' ? 1 : 0);
  const handleChapterNameChange = (e) => setCurrentChapterName(e.target.value);
  const handleChapterTimeChange = (e) => setCurrentChapterTime(e.target.value);

  const addChapter = () => {
    if (currentChapterName && currentChapterTime) {
      setChapterData([...chapterData, {
        title: currentChapterName,
        start: currentChapterTime
      }]); 
      setCurrentChapterName(''); 
      setCurrentChapterTime(''); 
    }
  };

  const removeChapter = (index) => {
    setChapterData(chapterData.filter((_, i) => i !== index)); 
  };

const uploadToOracle = async () => {
  if (!file) {
    setMessage({ type: "error", text: "Please fill all required fields." });
    return null;
  }

  const fileName = `${Date.now()}-${file.name}`;
  const fileUrl = `${ORACLE_STORAGE_URL}AppVideos/${project}/${subject}/${encodeURIComponent(fileName)}`;

  try {
    await axios.put(fileUrl, file, {
      headers: {
        "Content-Type": file.type,
        Authorization: AUTH_TOKEN,
      },
    });

    const updatedUrl = fileUrl.replace(
      "/p/jIul8gp04uV3Vwlb3zpEhXkRU1NVb8KdpdLMRya9OzTvgDs85JfcSd_kezfBr4IA",
      ""
    );

    return updatedUrl;

  } catch (error) {
    console.error("Oracle upload error:", error);
    setMessage({ type: "error", text: "Upload failed. Please try again." });
    return null;
  }
};


  const handleQuestionChange = (e) => setCurrentQuestion(e.target.value);
  const handleOptionChange = (e, index) => {
    const options = [...currentOptions];
    options[index] = e.target.value;
    setCurrentOptions(options);
  };
  const handleAnswerOptionChange = (e) => setCurrentAnswerOption(e.target.value);
  const handleQuestionTimeChange = (e) => {
    const value = e.target.value;
    setCurrentQuestionTime(value);
    const [hours, minutes] = value.split(':').map(Number);
    const totalMinutes = (hours || 0) * 60 + (minutes || 0);
    setCurrentQuestionTimeInMinutes(totalMinutes);
  };
  
  const handleExplanationChange = (e) => setCurrentExplanation(e.target.value);

  const addQuestion = () => {
    if (currentQuestion && currentAnswerOption && currentExplanation) {
      setQuestionData([...questionData, {
        question: currentQuestion,
        options: currentOptions,
        answer: currentAnswerOption,
        questionTime: currentQuestionTimeInMinutes,
        explanation: currentExplanation
      }]);
      setCurrentQuestion('');
      setCurrentOptions(['', '', '', '']);
      setCurrentAnswerOption('');
      setCurrentQuestionTime('');
      setCurrentExplanation('');
    }
  };

  const removeQuestion = (index) => {
    setQuestionData(questionData.filter((_, i) => i !== index));
  };

useEffect(() => {
  const fetchData = async () => {
    const storedMaterialData = JSON.parse(localStorage.getItem('materialData'));
    if (storedMaterialData) {
      setMaterialData(storedMaterialData);

      try {
        const response = await axios.get(`/getCourseDetails/${storedMaterialData.courseName}`, {
          headers: {
            'autherisation': `V9YlI4AgRJa97h9JT45acmijLliEcCEMnxZLtL7VlnWVETZuitk2MYoj0pCcrmHa`,
          }
        });
        console.log("response", response.data.data[0]);
        setProject(response.data.data[0].project === "" ? "null" : response.data.data[0].project);
        setSubject(response.data.data[0].subject);
      } catch (error) {
        console.error("Error fetching course details:", error);
      }
    }
  };

  fetchData();
}, []);

  return (
    <div>
      <div className={styles.mainHeadDiv}>
        <h3 className={styles.mainHead}>ADD ONLINE/LIVLINE VIDEO</h3>
        <div>
          <div className='row'>
            <div className='col-md-3'>
              <div className={styles.header}><strong>Course Name:</strong></div>
              <div className={styles.header}><strong>Topic Name:</strong></div>
              <div className={styles.header}><strong>SubTopic Name:</strong></div>
            </div>
            <div className='col-md-4'>
              <div className={styles.header}><span>{courseName}</span></div>
              <div className={styles.header}><span>{currentTopicName}</span></div>
              <div className={styles.header}><span>{currentSubTopicName}</span></div>
            </div>
          </div>
          {isLive ? (
            <></>
          ):(

            <Form.Check 
            type="switch"
            id="custom-switch"
            label="YouTube video"
            checked={isYoutube}
            onChange={(e) => setIsYoutube(e.target.checked)}
/>
          )}
          {isYoutube ? (
            <></>
          ):(

            <Form.Check 
            type="switch"
            id="custom-switch"
            label="Zoom Live Recorded video"
            checked={isLive}
            onChange={(e) => setIsLive(e.target.checked)}
/>
          )}
          <form onSubmit={handleAddNewVideo}>
            <div className='row'>
              <div className='col-md-6'>
                <div className={styles.inputDiv}>
                  <label htmlFor="caption"><strong>Material Caption</strong></label>
                  <Form.Control type="text" onChange={handleChangeCaption} required id="caption" placeholder="Give a Caption" />
                </div>
                <div className={styles.inputDiv}>
                  <label htmlFor="description"><strong>Description</strong></label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    id="description"
                    placeholder="Enter Description"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                  />
                </div>
                {!isYoutube ? (
 <div className={styles.inputDiv}>
<div className={`${styles.dropZone} ${dragActive ? styles.active : ''}`}
     onDragOver={handleDragOver}
     onDragLeave={handleDragLeave}
     onDrop={handleDrop}>
  <p>📂 Drag & drop your video here or click to select</p>
  <input type="file" accept="video/*" onChange={handleFile} required />
</div>
{file && (
  <div className={styles.fileName}>
    🎬 <strong>Selected File:</strong> {file.name}
  </div>
)}

</div>

) : (
  <div className={styles.inputDiv}>
    <label htmlFor="youtubeLink"><strong>YouTube Video Link</strong></label>
    <Form.Control type="text" onChange={handleChangeYoutubeLink} required={isYoutube} id="youtubeLink" placeholder="Enter YouTube Link" />
  </div>
)}
                <div className={styles.addBtns}>
                  <Button variant="outline-secondary" onClick={() => setShowChapterForm(true)} className="mb-2">
                    Click to add Chapters
                  </Button>
                </div>
                <Modal show={showChapterForm} onHide={() => setShowChapterForm(false)}>
                  <Modal.Header closeButton>
                    <Modal.Title>Set Chapter Times</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <div className="inputDiv">
                      <Form>
                        <label htmlFor="chapterName"><strong>Chapter Name</strong></label>
                        <Form.Control
                          type="text"
                          id="chapterName"
                          value={currentChapterName}
                          required
                          onChange={handleChapterNameChange}
                        />
                        <label htmlFor="chapterTime"><strong>Chapter Time</strong></label>
                        <Form.Control
                          type="time"
                          step="1"
                          id="chapterTime"
                          value={currentChapterTime}
                          required
                          onChange={handleChapterTimeChange} 
                        />
                        <div className={styles.addChapter}>
                          <Button variant="outline-warning" onClick={addChapter} className="mt-2">
                            <GrChapterAdd />  Add Chapter
                          </Button>
                        </div>
                      </Form>
                    </div>
                    {chapterData.length > 0 && (
                      <div className="mt-3">
                        <strong>Chapters Added:</strong>
                        <ListGroup>
                          {chapterData.map((chapter, index) => (
                            <ListGroup.Item key={index} className="d-flex justify-content-between align-items-center">
                              <div>{chapter.title} - {chapter.start}</div>

                              <Button
                                variant="outline-danger"
                                size="sm"
                                onClick={() => removeChapter(index)}
                              >
                                <CiSquareRemove />
                              </Button>
                            </ListGroup.Item>
                          ))}
                        </ListGroup>
                      </div>
                    )}
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="primary" onClick={() => setShowChapterForm(false)}>
                      Save Changes
                    </Button>
                  </Modal.Footer>
                </Modal>
                <br />
                {/* <div className={styles.inputDiv}>
                  <label htmlFor="updateDetails"><strong>Do you want to update more details?</strong></label>
                  <div className={styles.checkDiv}>
                    <Form.Check type="radio" name="updateDetails" label={`Yes`} id={`updateYes`} required />
                    <Form.Check type="radio" name="updateDetails" label={`No`} id={`updateNo`} required />
                  </div>
                </div> */}
              </div>
              <div className='col-md-6'>
                {/* <div className={styles.inputDiv}>
                  <label htmlFor="youtubeLink"><strong>Youtube Link</strong></label>
                  <Form.Control type="text" onChange={handleChangeYoutubeLink} id="youtubeLink" placeholder="Enter Youtube Link" />
                </div> */}
                <div className={styles.inputDiv}>
                  <label htmlFor="date"><strong>Date</strong></label>
                  <Form.Control type="date" id="date" onChange={handleChangeDate} required aria-label="Date" />
                  <Form.Control type="time" aria-label="Time" />
                </div>
                <div className={styles.inputDiv}>
                  <label htmlFor="publishDemo"><strong>Do you want to publish this as demo?</strong></label>
                  <div className={styles.checkDiv}>
                    <Form.Check type="radio" name="publishDemo" label={`Yes`} value={`publishYes`} onChange={handleChangePublishDemo} required />
                    <Form.Check type="radio" name="publishDemo" label={`No`} value={`publishNo`} onChange={handleChangePublishDemo} required />
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.addBtns}>
<Button type="submit" variant="outline-success" className="mb-2" disabled={isSubmitting}>
  {isSubmitting ? (
    <>
      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
      Submitting...
    </>
  ) : 'Submit'}
</Button>

            </div>
          </form>
        </div>
        <Modal show={showQuestionForm} onHide={handleCloseQuestionForm}>
          <Form onSubmit={handleAddVideoQuestion}>

            <Modal.Header closeButton>
              <Modal.Title>Set Questions</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form >
                <label><strong>Question</strong></label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={currentQuestion}
                  placeholder="Enter question"
                  onChange={handleQuestionChange}
                  required
                />
                <label><strong>Options</strong></label>
                {currentOptions.map((option, index) => (
                  <Form.Control
                    key={index}
                    type="text"
                    style={{ marginBottom: "10px" }}
                    placeholder={`Option ${index + 1}`}
                    value={option}
                    onChange={(e) => handleOptionChange(e, index)}
                    required
                  />
                ))}
                <div className="row">
                  <div className='col-md-6'>
                    <label><strong>Answer Option</strong></label>
                    <Form.Control type="number" value={currentAnswerOption} placeholder="Enter option number"
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value === "" || /^[1-4]$/.test(value)) {
                          handleAnswerOptionChange(e);
                        }
                      }}
                      onKeyDown={(e) => {
                        if (!["1", "2", "3", "4"].includes(e.key) && e.key !== "Backspace" && e.key !== "Delete") {
                          e.preventDefault();
                        }
                      }}
                      required
                    />
                  </div>
                  <div className='col-md-6'>
                    <label><strong>Question Time</strong></label>
                    <Form.Control
                      type="time"
                      step="1"
                      value={currentQuestionTime}
                      placeholder="Enter time"
                      onChange={(e) => handleQuestionTimeChange(e)}
                      required
                    />
                  </div>
                </div>
                <label><strong>Explanation</strong></label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={currentExplanation}
                  placeholder='Enter explanation here'
                  onChange={handleExplanationChange}
                  required
                />
                <div className={styles.addChapter}>
                  <Button variant="outline-warning" onClick={addQuestion} className="mt-2">
                    <GrChapterAdd /> Add Question
                  </Button>
                </div>
              </Form>

              {questionData.length > 0 && (
                <div className="mt-3">
                  <strong>Added Questions:</strong>
                  <ListGroup>
                    {questionData.map((question, index) => (
                      <ListGroup.Item key={index} className="justify-content-between align-items-center">
                        <div>Question: {question.question}</div>
                        <div>Answer: {question.answer}</div>
                        <div>Question Time: {question.questionTime}</div>
                        <div>Explanation: {question.explanation}</div>
                        <div>Options: <ol>
                          {question.options.map((option, index) => <li>{option}</li>)}</ol>
                        </div>
                        <div className={styles.addChapter}>
                          <Button
                            variant="outline-danger"
                            size="sm"
                            onClick={() => removeQuestion(index)}
                          >
                            <CiSquareRemove className='fs-5' />
                          </Button>
                        </div>
                      </ListGroup.Item>
                    ))}
                  </ListGroup>
                </div>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button variant="light" onClick={handleCloseQuestionForm}>
                Cancel
              </Button>
              <Button variant="outline-primary" type='submit'>
                Save Changes
              </Button>
            </Modal.Footer>

          </Form>
        </Modal>
      </div>
    </div>
  );
};

export default AddNewVideo;
